import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Form, Field } from 'react-final-form'

import userActions from '../../context/users/actions';
import filesActions from '../../context/files/actions';
import internalsActions from '../../context/internals/actions';
import { ToastContainer, notify } from '../../libraries/notifications';
import { isEmptyObject,  validateIsfilled } from '../../libraries/utils';
import { history } from '../../routes';
import config from '../../config';

import LayoutSmall from '../../components/layout/LayoutSmall';
import Button from '../../components/commons/Button';
import RadioInput from '../../components/forms/RadioInput';
import Icon from '../../libraries/icons';

class UserInfo extends React.Component {
  constructor(props) {
    super(props);
    this.t = this.props.t;
    this.state = {
      submitting: false,
      imageUpdated: false,
      selectedFile: null,
      profile_image: null,
      user: null,
      files: {},
      currentDesafio: 0,
      desafios: null,
    }
  }
  
  componentDidMount() {
    if (isEmptyObject(this.props.location.state)) { 
      history.push(config.ROUTES.HOME);
    } else {
      const { identification, valuesFromVerification, desafios, id_consulta, preRegistered } = this.props.location.state;
      this.setState({identificationFromState:identification, valuesFromVerification, desafios, id_consulta, preRegistered}, this.getQuestionsWithIdentification)
    }
  
  }

  getQuestionsWithIdentification = async () => {
//      await this.props.onGetQuestions({identification: this.state.identificationFromState})
//      console.log(this.props.internals.error)//this.props.internals.resultado["Novedad"]
//      const internals_error = this.props.internals.error;
//      if (internals_error) {
//        notify(this.t(internals_error.message + " " ));
//        this.setState({"error": internals_error.message})
//      } else {
//        console.log("this.props.internals", this.props.internals)
//        const {Desafios, IdConsulta, Novedad, Estado} = this.props.internals.questions
//
//        if(Estado !== 200){
//          this.setState({"error": `Error: ${Novedad}`})
//          //this.setState({ user });
//          return
//        }
//        
//        this.setState({desafios: Desafios, id_consulta: IdConsulta})
//      }
  }

  gotoBack = async () => {
    // await this.props.onGetToken();
    // if (this.props.auth.error) notify(this.t(this.props.auth.error.message));
    history.push(config.ROUTES.SIGNUP_VERIFICATION2);
  }

  gotoHome = async () => {
     history.push(config.ROUTES.HOME);
  }

  gotoSignup = async () => {
    history.push({pathname: config.ROUTES.SIGNUP, state: {
      identification:this.state.identificationFromState,
      valuesFromVerification: this.state.valuesFromVerification,
      preRegistered: this.state.preRegistered,
    }});
  }

  onSubmit = async values => {
    const { currentDesafio, desafios, id_consulta } = this.state
    if(!values["p"+currentDesafio]){
      this.setState({showNextErrorLabel: true})
      return
    }

    this.setState({ submitting: true });
    console.log("values", values)
    
    //RESPUESTAS
    let pregunta_index = 0
    let Cuestionario = "" 
    desafios.forEach(d => {
      let respuesta_index = d["Pregunta"]["Opciones"].findIndex(o => o === values["p"+pregunta_index])
      Cuestionario += `${d["Pregunta"]["IdPregunta"]}-${respuesta_index},`
      pregunta_index += 1
    })

    Cuestionario = Cuestionario.slice(0,Cuestionario.length-1)

    console.log("values", Cuestionario)

    let data = {answers: Cuestionario, id: id_consulta}
    await this.props.onVerify(data);
    const error = this.props.internals.error;
    if (error) {
      this.setState({ submitting: false });
      notify(this.t(error.message));
    } else {
      let result = this.props.internals.verify?.Estado
      console.log("RESULT", this.props.internals, this.props.internals.verify?.Estado)
      this.setState({verificationEnded: true, aproved: result === "APROBADO"})

      // if(result === "APROBADO"){
      //   signupData.birth_date = signupData.birthdate
      //   delete signupData.birthdate
      //   this.verifyInUser(signupData)
      //   this.verifyInUser({json_data: {verified: "verified"}})
      // }
    }
  }

  verifyInUser = async (newData) => {
    let data = { id:this.state.user.id, ...newData , user_type:"patient" }
    await this.props.onUpdate(data);
    const error = this.props.user.error;
    if (error) {
      this.setState({ submitting: false });
      notify(this.t(error.message));
    }
  }

  nextDesafio = (v) => {
    console.log(v)
    const {currentDesafio} = this.state
    if(!v["p"+currentDesafio]){
      this.setState({showNextErrorLabel: true})
      return
    }
    
    if(currentDesafio !== this.state.desafios.length-1){
      this.setState({currentDesafio: currentDesafio+1, showNextErrorLabel: false})
    }
  }

  previousDesafio = (v) => {
    const {currentDesafio} = this.state
    if(currentDesafio !== 0){
      this.setState({currentDesafio: currentDesafio-1, showNextErrorLabel: false})
    }    
  }

  render() {
    const { user, verificationEnded, aproved, nameFromState, identificationFromState, valuesFromVerification } = this.state;
    if (this.state.profile_image) {
      console.log('AVATAR UPLOADED');
      user.profile_image = this.state.profile_image;
    }
    const required = value => (validateIsfilled(value) ? undefined : this.t("This field is required"))

    const verified = user?.json_data?.verified

    return (
      <LayoutSmall
        main={{ className: "bg-base-200 bg-pattern"}}
        header={{ 
          className: "!bg-transparent !text-primary",
          left: { icon: 'arrow_left', action: () => this.gotoBack() },
          title: this.t("Verificación")
        }}
        loading={this.props.user.loading}
        container={{ className: "px-0"}}
      >
        <ToastContainer/>
        <section className="text-center px-3 pt-2 pb-8 flex "> 
          <div className="center mx-auto card white px-10">
            <div className="px-4 py-3 rounded-lg text-center">
              {/*<div className="rounded-full bg-primary-focus overflow-hidden flex items-center text-center m-auto w-28 h-28">
                {user && user.profile_image ? (
                  <img className="w-full h-auto" src={user && user.profile_image} alt="" />
                ) : (
                  <span className="m-auto text-white text-2xl">{user && user.name}</span>
                )}
              </div>*/}
              <label className="cursor-pointer mt-6">
                <p className=" mb-2 text-secondary-content">{valuesFromVerification?.first_name} {valuesFromVerification?.last_name}</p>
              </label>
              <label className="cursor-pointer mt-6">
                <p className=" mb-2 text-base-content">{identificationFromState}</p>
              </label>
              {/*<label className="cursor-pointer mt-6">
                <span className="btn btn-secondary btn-sm mt-3">{this.t("Upload a photo")}</span>
                <input type='file' className="hidden" multiple="multiple" accept="accept" onChange={this.onFileChange} />
              </label>*/}
            </div>            
          </div>
        </section>
        <section className="px-4 -mt-5">

          {!verificationEnded && 
          <Form 
            //initialValues={user || {}}
            onSubmit={this.onSubmit}
          >
            {({ handleSubmit, form, submitting, pristine, values }) => (
              <form onSubmit={handleSubmit} className="w-full max-w-lg mx-auto">
                <div className="p-4 mb-6">
                {this.state.error && <div>{this.state.error}. No se puede verificar el usuario.</div>}

                  {this.state.showNextErrorLabel && <p>Debe seleccionar una opción para continuar</p>}
                 {this.state.desafios && <div className="w-full mb-3 md:mb-0">
                    {this.state.desafios.map((desafio, desafio_index) => {
                      if(desafio_index !== this.state.currentDesafio) return null
                      return (
                        <div>
                          <label className='label-text text-lg mb-5 block' key={desafio_index}>{desafio.Pregunta.Texto}</label>
                          <div className="">
                            {desafio.Pregunta.Opciones.map((opcion, index) => {
                              return (
                                <div className="" >
                                  <Field  key={"opcionpregunta"+index} type="radio" value={opcion} name={"p"+desafio_index} component={RadioInput} labelClassName="block" label={opcion} setExternal={()=>{}}/>
                                </div>)
                            })}

                          </div>
                        </div>
                      )
                    })}
                  <div className='flex items-center gap-5'>
                    {this.state.currentDesafio !== 0 && <Button className="btn-primary btn-outline btn-block flex-1" title={this.t("Anterior")} onClick={() => this.previousDesafio(values)}/>}
                    {this.state.currentDesafio !== this.state.desafios.length-1 && <Button className="btn-primary btn-block flex-1" title={this.t("Próxima")} onClick={() => this.nextDesafio(values)}/>}
                    {this.state.currentDesafio === this.state.desafios.length-1 && <Button className="btn-primary btn-block flex-1" title={this.t("Enviar")} onClick={handleSubmit}/>}
                  </div>
                </div>}



                </div>
              </form>
            )}
          </Form>}

          {verificationEnded && aproved &&
            /*VERIFICACION APROBADA*/
            <div className="w-full max-w-lg mx-auto px-4 h-full flex flex-col items-center pt-28">
              <div className="p-4 mb-6">
                <Icon className="h-36 w-36 mb-6 m-auto text-success" name="badge_check" />
                <p className="text-success text-lg text-center">Verificación aprobada</p>
                <p className='text-gray'>Continue ahora con la registración</p>
              </div>
              <Button className="btn-primary btn-block" title={this.t("Continuar")} onClick={this.gotoSignup}/>
            </div>}

          {verificationEnded && !aproved &&
            /*VERIFICACION RECHAZADA*/
            <div className="w-full max-w-lg mx-auto px-4 h-full flex flex-col items-center pt-28">
              <div className="p-4 mb-6">
                <Icon className="h-36 w-36 mb-6 m-auto text-error" name="x_circle" />
                <p className="text-error text-lg text-center">Verificación Rechazada</p>
              </div>
              <Button className="btn-primary btn-outline btn-block" title={this.t("Volver")} onClick={this.gotoHome}/>
            </div>}
        </section>
      </LayoutSmall>
    ) 
  }
}

const mapStateToProps = state => {
  return {
    user: state.users.current,
    auth: state.users.auth,
    files: state.files,
    internals: state.internals,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onUpdate: (params) => dispatch(userActions.saveOrUpdate(params)),
    onGetUser: (params) => dispatch(userActions.get(params)),
    onPictureUpload: (params) => dispatch(filesActions.upload(params)),
    onGetToken: () => dispatch(userActions.getFromToken()),
    onGetQuestions: (params) => dispatch(internalsActions.postQuestions(params)),
    onVerify: (params) => dispatch(internalsActions.postVerify(params)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(UserInfo));
